import request from '@/utils/request'

function login (ubn, email, password) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      username: `${email}|${ubn}`,
      password: password
    }
  })
}

export default {
  login
}
